import { Injectable } from '@angular/core';
import { PromiseResult } from '../models/PromiseResult';
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class JsonDataService {

  constructor(private readonly http: HttpClient) { }

  async getConsultationData() {
    const res = await this.http.get<PromiseResult>('assets/data/counts_consultation.json')
      .toPromise();
    return res as PromiseResult;
  }

  async getPatientVideoData() {
    const res = await this.http.get<PromiseResult>('assets/data/patientvideos.json')
      .toPromise();
    return res as PromiseResult;
  }

  async getDoctorVideoData() {
    const res = await this.http.get<PromiseResult>('assets/data/doctorvideos.json')
      .toPromise();
    return res as PromiseResult;
  }

  async getCommonHealthIssues()
  {
    const res = await this.http.get<PromiseResult>('assets/data/commonissues.json')
    .toPromise();
    return res as PromiseResult;
  }
}




